import { useAuthorizedUser } from '@app/auth/useAuthorizedUser';
import { ETeamMemberRole } from '@app/swagger-types';

export const useCurrentTeam = () => {
  const { currentUser: user } = useAuthorizedUser();

  const teamId = user?.teamId;
  const isVisibleToAllOrOwnerOnly =
    user?.teamMemberRole === ETeamMemberRole.OWNER || user?.teamMemberRole === ETeamMemberRole.NONE;

  return {
    teamId,
    isVisibleToAllOrOwnerOnly,
  };
};
